import React from 'react'
import Checkbox from 'app/theme/forms/Checkbox'

export default function ListingEquipmentFilter({ equipment, featureCategories, updateVehicleFeatures }) {

  if (!featureCategories.data?.length) {
    return null
  }

  // get the index of the Extras category
  const extrasIndex = featureCategories.data?.findIndex(category => category.code === "extras")
  // create a copy of the extras category while removing it from featureCategories
  const extrasCategory = featureCategories.data?.splice(extrasIndex, 1)
  // re-inject the extras category at position 4
  featureCategories.data?.splice(3, 0, extrasCategory[0])

  return (
    <div className="my-6 md:my-0">
      <h3 className="text-md text-black font-bold mb-4">Equipment</h3>
      <div className="w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-12">
        {
          featureCategories.data?.map(category => (
            <div key={category.id} className={["mb-6", (category.code === 'extras' || category.code === 'cooking' ? 'col-span-2 lg:col-span-3' : '')]}>
              <h4 className="block uppercase tracking-widest text-gray-900 font-bold text-xs mb-2">
                {category.name}
              </h4>
              <hr />
              <div className={category.code === 'extras' || category.code === 'cooking' ? 'grid grid-cols-2 lg:grid-cols-3' : ''}>
                {category.vehicle_features.map(feature => (
                  <Checkbox
                    label={feature.name}
                    key={feature.id}
                    className="checkbox-sm mt-2"
                    checked={equipment?.includes(feature.id)}
                    onChange={checked => {
                      updateVehicleFeatures(feature, checked)
                    }}
                  />
                  ))}
              </div>
            </div>
          ))
        }
      </div>
    </div>
  )
}